import React from 'react';
import TweenOne from 'rc-tween-one';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';

class Footer extends React.Component {

  static defaultProps = {
    className: 'footer0',
  };

  render() {
    const props = { ...this.props };
    delete props.isMode;
    return (<OverPack
      {...props}
      playScale={0.05}
    >
      <TweenOne
        animation={{ y: '+=30', opacity: 0, type: 'from' }}
        key="footer"
      >
        <span id={`${props.id}-content`}>
          版权所有 © 2017 北京回一科技有限公司
<br />Copyright © 2017 HooYee. All Rights Reserved
<br /><a href="http://www.miitbeian.gov.cn/" target="_blank">京ICP备18014350号-8</a>
        </span>
      </TweenOne>
    </OverPack>);
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Home/Footer.jsx